const env = {
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as string,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string,
    appId: import.meta.env.VITE_FIREBASE_APP_ID as string,
  },
  onesignal: {
    appId: import.meta.env.VITE_ONESIGNAL_APP_ID as string | undefined,
    allowedOrigin: import.meta.env.VITE_ONESIGNAL_ALLOWED_ORIGIN as string | undefined,
  },
  appCheck: {
    siteKey: import.meta.env.VITE_FIREBASE_APP_CHECK_SITE_KEY as string | undefined,
    debugToken: import.meta.env.VITE_FIREBASE_APP_CHECK_DEBUG_TOKEN as string | undefined,
  },
  workerUrl: import.meta.env.VITE_WORKER_URL as string | undefined,
  canonicalOrigin: import.meta.env.VITE_CANONICAL_ORIGIN as string | undefined,
  canonicalRedirectOrigins: import.meta.env.VITE_CANONICAL_REDIRECT_ORIGINS as string | undefined,
} as const;

const requiredFirebaseEnv = {
  VITE_FIREBASE_API_KEY: env.firebase.apiKey,
  VITE_FIREBASE_AUTH_DOMAIN: env.firebase.authDomain,
  VITE_FIREBASE_PROJECT_ID: env.firebase.projectId,
  VITE_FIREBASE_STORAGE_BUCKET: env.firebase.storageBucket,
  VITE_FIREBASE_MESSAGING_SENDER_ID: env.firebase.messagingSenderId,
  VITE_FIREBASE_APP_ID: env.firebase.appId,
} as const;

export function getEnv() {
  return env;
}

export function getMissingFirebaseConfig(): string[] {
  return Object.entries(requiredFirebaseEnv)
    .filter(([, value]) => !value)
    .map(([key]) => key);
}

export function isFirebaseConfigured(): boolean {
  return getMissingFirebaseConfig().length === 0;
}
